import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { AdobeExperiencePlatformLinkedService } from 'app/model/linkedservice/adobe-experience-platform.linkedservice';
import _ from 'lodash';
import { AdobeExperiencePlatformCopySource } from 'app/model/pipeline/copysource/adobe-experience-platform.copysource';

export const adobeExperiencePlatformMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(AdobeExperiencePlatformLinkedService).name,
    displayName: stringResources.AdobeExperiencePlatform_DisplayText,
    linkedServiceKind: 'file',
    icon: {
        className: 'svg-i-20x20-AdobeExperiencePlatform'
    },
    onlyAzureIR: true,
    isFirstClass: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(AdobeExperiencePlatformCopySource).name],
    fileNameDisplay: 'dataset id',
    notSupportCompression: true,
    controls: [
        {
            type: 'textbox',
            bind: 'apiKey',
            label: stringResources.ModelName_APIKey,
            description: stringResources.AdobeExperiencePlatform_ApiKeyDescription,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'accountId',
            label: stringResources.ModelName_AccountID,
            description: stringResources.AdobeExperiencePlatform_AccountIdDescription,
            placeholder: 'E.g. id@techacct.adobe.com',
            isLabelVertical: true,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ]
        },
        {
            type: 'textbox',
            bind: 'orgId',
            label: stringResources.ModelName_OrgID,
            description: stringResources.AdobeExperiencePlatform_OrgIdDescription,
            placeholder: 'E.g. org_ident@AdobeOrg',
            isLabelVertical: true,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ]
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'clientSecret',
            label: stringResources.ModelName_ClientSecret,
            child: {
                type: 'password',
                label: stringResources.ModelName_ClientSecret,
                description: stringResources.AdobeExperiencePlatform_ClientSecretDescription,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AdobeExperiencePlatform_DisplayText),
                stringResources.ModelName_ClientSecret)
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'privateKeyContent',
            label: stringResources.ModelName_PrivateKeyContent,
            child: {
                type: 'key-file-content',
                label: stringResources.ModelName_PrivateKeyContent,
                readAsText: true,
                description: stringResources.AdobeExperiencePlatform_PrivateKeyContentDescription,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AdobeExperiencePlatform_DisplayText),
                stringResources.ModelName_PrivateKeyContent)
        }
    ]
};
